import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, Grid, Icon, IconButton, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ICreateBordero, ISinisterValues, SinisterService } from "../../../../shared/services/api/sinister/SinisterService";
import { TableDetailBordero } from "../TableDetailBordero";
import { useState } from "react";
import { addMonths, format } from "date-fns";
import { useToast } from "../../../../shared/hooks";
import { ToastContent } from "../../../../shared/components";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";

interface ModalGenerateProps {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
	rows: ISinisterValues[];
	clientId: string;
	sinisterId: string;
}

export const ModalGenerateBordero = ({ open, onClose, onSuccess, rows, clientId, sinisterId }: ModalGenerateProps) => {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const [isLoading, setIsLoading] = useState(false);
	const toastHandler = useToast();

	const handleGenerateBordero = async () => {
		if (!checkByProfileGuard(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.GenerateBordero)) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Sem permissão" content="Seu usuário não tem permissão para gerar Borderô." />,
			});
			return;
		}

		setIsLoading(true);
		try {
			const ivalores = rows?.map((element) => ({
				id: element.id || "",
			}));

			const data: ICreateBordero = {
				sinisterValuesRequest: ivalores,
				dueDate: format(new Date(addMonths(new Date(), 1)), "yyyy-MM-dd HH:mm:ss"),
				sinisterId: sinisterId,
				clientId: clientId,
			};

			const result = await SinisterService.generateBordero(sinisterId, data);

			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Registro gravado com sucesso" />,
			});

			onSuccess();
			onClose();
		} catch (error: any) {
			console.error("Erro ao gerar bordereau:", error);
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: (
					<ToastContent title="Erro ao gerar bordereau" content={error?.message || "Ocorreu um erro inesperado. Tente novamente mais tarde."} />
				),
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<LoadingComp isopen={isLoading} />
			<Modal open={open} onClose={onClose}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 4,
						width: "95%",
						maxWidth: 720,
						maxHeight: "90vh",
						overflowY: "auto",
						borderRadius: 3,
					}}
				>
					<Grid container justifyContent="space-between" alignItems="center">
						<Typography variant="h4" sx={{ color: "primary.main", fontWeight: 300 }}>
							Geração de Borderô
						</Typography>
						<IconButton onClick={onClose} size="small">
							<CloseIcon />
						</IconButton>
					</Grid>

					<Divider sx={{ my: 2 }} />

					{/* Usa as linhas diretamente e desativa o fetch */}
					<TableDetailBordero disableFetch rows={rows} />

					<Grid container justifyContent="flex-end" flexDirection={smDown ? "column" : "row"} gap={2} mt={3}>
						<Button color="inherit" variant="contained" startIcon={<Icon>arrow_back</Icon>} onClick={onClose} sx={{ minWidth: 140 }}>
							Voltar
						</Button>
						<Button
							color="primary"
							variant="contained"
							startIcon={<Icon>check</Icon>}
							onClick={() => {
								handleGenerateBordero();
								//onClose();
							}}
							sx={{ minWidth: 140 }}
						>
							Confirmar
						</Button>
					</Grid>
				</Box>
			</Modal>
		</>
	);
};
